<template>
  <div class="site-wrapper" :class="{ 'site-sidebar--fold': sidebarFold }" v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中">
    <template v-if="!loading">
      <MainNavbar />
      <div class="site-content__wrapper" :style="{ 'min-height': documentClientHeight + 'px','margin-left':0,'width':'100%'}">

        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </template>

  </div>
</template>

<script>
import MainNavbar from "./main-navbarwarp";

export default {
  provide() {
    return {
      // 刷新
      refresh() {
        this.$store.commit("common/updateContentIsNeedRefresh", true);
        this.$nextTick(() => {
          this.$store.commit("common/updateContentIsNeedRefresh", false);
        });
      },
    };
  },
  data() {
    return {
      loading: true,
    };
  },
  components: {
    MainNavbar,
  },
  computed: {
    documentClientHeight: {
      get() {
        return this.$store.state.common.documentClientHeight;
      },
      set(val) {
        this.$store.commit("common/updateDocumentClientHeight", val);
      },
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
    userId: {
      get() {
        return this.$store.state.user.id;
      },
      set(val) {
        this.$store.commit("user/updateId", val);
      },
    },
    userName: {
      get() {
        return this.$store.state.user.name;
      },
      set(val) {
        this.$store.commit("user/updateName", val);
      },
    },
    workingSpace: {
      get() {
        return this.$store.state.user.workingSpace;
      },
      set(val) {
        this.$store.commit("user/setWorkingSpace", val);
      },
    },
    nickName: {
      get() {
        return this.$store.state.user.nickName;
      },
      set(val) {
        this.$store.commit("user/setNickName", val);
      },
    },
    createTime: {
      get() {
        return this.$store.state.user.createTime;
      },
      set(val) {
        this.$store.commit("user/setCreateTime", val);
      },
    },
    workingSpaceShow: {
      get() {
        return this.$store.state.user.workingSpaceShow;
      },
      set(val) {
        this.$store.commit("user/setWorkingSpaceShow", val);
      },
    },
    placeId: {
      get() {
        return this.$store.state.user.placeId;
      },
      set(val) {
        this.$store.commit("user/setPlaceId", val);
      },
    },
    samplingSite: {
      get() {
        return this.$store.state.user.samplingSite;
      },
      set(val) {
        this.$store.commit("user/setSamplingSite", val);
      },
    },
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    this.resetDocumentClientHeight();
  },
  methods: {
    // 重置窗口可视高度
    resetDocumentClientHeight() {
      this.documentClientHeight = document.documentElement["clientHeight"] - 50;
      window.onresize = () => {
        this.documentClientHeight =
          document.documentElement["clientHeight"] - 50;
      };
    },
    // 获取当前管理员信息
    getUserInfo() {
      this.loading = false;
      this.userId = 1;
      this.userName = "admin";
      this.nickName = "admin";
    },
  },
};
</script>
<style scoped>
.textarea-div /deep/ textarea {
  height: 180px;
}
</style>





